<template>
    <div :id="page.slug" class="page-content">
        <div class="container">
            <div class="heading">
                <h1>{{ page.title }}</h1>
                <p>{{ page.subtitle }}</p>
            </div>
        </div>

        <div class="featured-image">
            <div
                :style="{ backgroundImage: 'url(' + appUrl + page.image + ')' }"
                class="banner-img lazyload"
            >
                <div class="banner-credits">
                    <div class="container">
                        <a
                            href="https://unsplash.com/@jofator?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge"
                            target="_blank"
                            class="unsplash-credits"
                            rel="noreferrer"
                        >
                            <span class="unsplash-logo">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 32 32"
                                >
                                    <title>unsplash-logo</title>
                                    <path
                                        d="M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z"
                                    ></path>
                                </svg>
                            </span>
                            <span class="unsplash-text">
                                <p class="text1">Josef Grabner</p>
                                <p class="text2">@jofator</p>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="full-width">
            <div class="container">
                <div class="form-container">
                    <h3>Send us a job request</h3>
                    <p>We will get back to you as soon as possible!</p>

                    <el-form
                        ref="form"
                        v-loading="loading"
                        :model="form"
                        :rules="rules"
                        label-position="top"
                        @submit.prevent.native="submitForm"
                    >
                        <el-row :gutter="20">
                            <el-col :xs="24">
                                <el-form-item prop="name" label="Name">
                                    <el-input v-model="form.name"> </el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24">
                                <el-form-item prop="email" label="Email">
                                    <el-input v-model="form.email" type="email">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24">
                                <el-form-item prop="phone" label="Phone">
                                    <el-input v-model="form.phone"> </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24">
                                <el-form-item
                                    prop="prev_employer"
                                    label="Previous Employer (if applicable)"
                                >
                                    <el-input v-model="form.prev_employer">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24">
                                <el-form-item prop="message" label="Message">
                                    <el-input
                                        v-model="form.message"
                                        type="textarea"
                                        :autosize="{ minRows: 6, maxRows: 8 }"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item :style="{ marginBottom: '0' }">
                            <el-button type="primary" native-type="submit">
                                Send
                                <i class="el-icon-finished" />
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    async asyncData({ app, store, error }) {
        await store
            .dispatch('general/getPage', app.context.route.name)
            .catch((e) => {
                error({
                    statusCode: e.response.status,
                    message: 'Page not found'
                })
            })
    },

    data() {
        return {
            form: {
                name: '',
                email: '',
                phone: '',
                prev_employer: '',
                message: '',
                captcha: ''
            },
            rules: {
                name: {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur'
                },
                email: [
                    {
                        required: true,
                        message: 'This field is required',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Please enter valid email',
                        trigger: 'blur'
                    }
                ],
                message: {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur'
                }
            },
            loading: false
        }
    },
    head() {
        return {
            title: this.page.title,
            meta: [
                {
                    hid: 'title',
                    name: 'title',
                    content: this.page.meta_title
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: this.page.meta_description
                }
            ]
        }
    },

    computed: {
        ...mapGetters({
            page: 'general/page'
        }),
        appUrl() {
            return process.env.appUrl
        }
    },

    async mounted() {
        await this.$recaptcha.init()
    },

    methods: {
        async submitForm() {
            try {
                const token = await this.$recaptcha.execute()
                this.form.captcha = token

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$store
                            .dispatch('general/jobs', this.form)
                            .then((resp) => {
                                this.loading = false
                                this.$message({
                                    message: resp.message,
                                    type: 'success'
                                })
                                this.form = {
                                    name: '',
                                    email: '',
                                    phone: '',
                                    prev_employer: '',
                                    message: '',
                                    captcha: ''
                                }
                            })
                    } else {
                        return false
                    }
                })
            } catch (error) {
                console.log('Recaptcha error:', error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#jobs-img {
    display: block;
    width: 100%;
    border-radius: 4px;
}

.full-width {
    display: inline-block;
    width: 100%;
    background: $floral-white;
    padding: 3em 0;
    background-image: url('~assets/images/ovale.svg');
    background-repeat: no-repeat;
    background-size: auto 167%;
    background-position: -109% 141%;
}

.form-container {
    max-width: 500px;
    margin: 0 auto;

    h3 {
        text-align: center;
        box-sizing: inherit;
        border: 0px solid;
        margin-bottom: 0px;
        font-size: 1.125rem;
        color: rgb(0, 0, 0);
    }

    p {
        text-align: center;
        color: rgb(107, 165, 74);
        font-weight: normal;
        font-size: 14px;
        line-height: 26px;
        white-space: pre;
    }
}

@media only screen and (max-width: 767px) {
    .el-form {
        margin-top: 2em;
        padding: 2em;
    }

    .el-row {
        margin-left: -15px !important;
        margin-right: -15px !important;

        .el-col {
            padding-left: 15px !important;
            padding-right: 15px !important;
        }
    }
}

@media only screen and (max-width: 991px) {
    .full-width {
        padding: 2em 0;
    }
}
</style>
